import { combineReducers } from "redux"

import Navigation from "./Navigation"
import Page from "./Page"
import UI from "./UI"

export default combineReducers({
	Navigation,
  	Page,
  	UI
})



// WEBPACK FOOTER //
// ./src/js/redux/reducers/index.js